import styled from "styled-components";

import { TEXT_PRIMARY } from "@/constants/colors";
import { BOLD } from "@/constants/fonts";

export const RefundHeaderText = styled.span`
  padding: 16px 0;
  display: inline-block;
`;

export const RefundTotalText = styled.span`
  color: ${TEXT_PRIMARY};
  font-size: 16px;
  font-weight: ${BOLD};
  padding: 16px 0;
  display: inline-block;
`;
